export default {
      id: "LWS-1px-usage",
      viewBox: "0 0 60 32",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-1px",
      toString: function () {
        return this.url;
      }
    }